import React from 'react';
import { Grid, SimpleModal, Typography } from '@nextiva/next-ui-components';
import { LabelText } from './DataImport.styles';

const FileModal = ({ file, closeModal, open }) => {
  return (
    <SimpleModal
      title="File details"
      confirmText="Close"
      open={open}
      confirmButtonProps={{
        onClick: closeModal,
        'data-testid': 'PlatformAdminUI-UserImports-CloseViewButton',
      }}
      onClose={closeModal}
    >
      <Grid
        container
        flexDirection="column"
        sx={{ width: '30vw', height: '20vh' }}
        justifyContent="space-between"
      >
        <Grid container flexDirection="row" alignItems="center">
          <Grid item xs={4}>
            <LabelText variant="body2">Name</LabelText>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">{file.name}</Typography>
          </Grid>
        </Grid>
        <Grid container flexDirection="row" alignItems="center">
          <Grid item xs={4}>
            <LabelText variant="body2">Size</LabelText>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">{file.size / 1000} kb</Typography>
          </Grid>
        </Grid>
        <Grid container flexDirection="row" alignItems="center">
          <Grid item xs={4}>
            <LabelText variant="body2">Last modified</LabelText>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">
              {new Date(file.lastModified).toDateString()}
            </Typography>
          </Grid>
        </Grid>
        <Grid container flexDirection="row" alignItems="center">
          <Grid item xs={4}>
            <LabelText variant="body2">Created</LabelText>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2">{new Date().toDateString()}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </SimpleModal>
  );
};

export default FileModal;
